throw new Error(
  'Do not import from the top-level of @clerk/shared directly. Import from specific subpaths like @clerk/shared/react or @clerk/shared/authorization instead.',
);

export {};
// Force rebuild for explicit exports (replacing wildcard)
